import React, { useState } from "react";
import { MaskLine } from "../components/Motion";
import { sendContact } from "../lib/api";
import { toast } from "sonner";
import { Instagram, Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try { const r = await sendContact(form); setSent(true); toast.success(r.message); }
    catch { toast.error("Something went wrong. Try again."); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-16 sm:py-24 grid lg:grid-cols-2 gap-16" data-testid="contact-page">
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">Get in touch</p>
        <h1 className="font-display font-extrabold text-6xl sm:text-7xl uppercase leading-[0.85]">
          <MaskLine>Contact</MaskLine>
        </h1>
        <p className="text-graytx mt-6 max-w-sm leading-relaxed">
          Questions about the drop, your pre-order, or a collab? Send it over — we reply within 48 hours.
        </p>
        <div className="mt-8 space-y-3 font-mono text-[11px] uppercase tracking-[0.2em]">
          <a href="mailto:hey@covertswag.com" className="flex items-center gap-3 hover:text-cs-yellow transition-colors duration-200"><Mail size={15} /> hey@covertswag.com</a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-cs-yellow transition-colors duration-200"><Instagram size={15} /> @covertswag</a>
        </div>
      </div>

      {sent ? (
        <div className="flex items-center" data-testid="contact-success">
          <p className="font-editorial text-3xl leading-tight text-cs-green">Message received.<br /><span className="text-cream">We'll be in touch within 48 hours.</span></p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
          {["name", "email"].map((k) => (
            <div key={k}>
              <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">{k}</label>
              <input required type={k === "email" ? "email" : "text"} value={form[k]} onChange={set(k)}
                data-testid={`contact-${k}`}
                className="w-full bg-transparent border-b border-line focus:border-cream py-3 outline-none transition-colors duration-200" />
            </div>
          ))}
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">Message</label>
            <textarea required rows={5} value={form.message} onChange={set("message")}
              data-testid="contact-message"
              className="w-full bg-transparent border-b border-line focus:border-cream py-3 outline-none resize-none transition-colors duration-200" />
          </div>
          <button data-testid="contact-submit" className="bg-cream text-bg font-mono text-[12px] uppercase tracking-[0.2em] px-10 py-4 hover:bg-cs-yellow transition-colors duration-200">Send Message</button>
        </form>
      )}
    </div>
  );
}
